function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function Trash({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.434 1c.964 0 1.83.646 2.153 1.606l.693 2.056h2.61a1 1 0 110 2h-.176v12.905a3.311 3.311 0 01-3.306 3.308h-9.99a3.312 3.312 0 01-3.307-3.308V6.662H4a1 1 0 110-2h2.6l.672-2.038C7.59 1.653 8.458 1 9.43 1h6.004zm3.285 5.662H6.106v12.905c0 .724.588 1.312 1.312 1.312h9.99c.723 0 1.311-.588 1.311-1.312V6.662zM12.36 7.927a1 1 0 011 1v9a1 1 0 11-2 0v-9a1 1 0 011-1zM8.868 9.275a1 1 0 011 1v6.5a1 1 0 11-2 0v-6.5a1 1 0 011-1zm6.984 0a1 1 0 011 1v6.5a1 1 0 11-2 0v-6.5a1 1 0 011-1zm-.418-6.368H9.43c-.146 0-.286.126-.347.313l-.475 1.442h7.659l-.487-1.446c-.062-.185-.2-.31-.346-.31z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}

const MemoTrash = React.memo(Trash);
export default MemoTrash;